import dayjs from 'dayjs';

export class PaykassmaConverter {}
